import { useEffect, useState } from "react";

// Brief intro splash: the logo self-composes from a point (icon pops up from a
// dot, then the wordmark rises, then a gold line draws) before entering the site.
// Shown once per browser session so it never annoys returning navigations.
export default function SplashScreen() {
  const [show, setShow] = useState(() => {
    try {
      if (typeof window === "undefined") return false;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
      return !sessionStorage.getItem("md_splash");
    } catch {
      return false;
    }
  });
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!show) return;
    try { sessionStorage.setItem("md_splash", "1"); } catch {}
    const t1 = setTimeout(() => setLeaving(true), 2050);
    const t2 = setTimeout(() => setShow(false), 2650);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [show]);

  if (!show) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-bone transition-opacity duration-500 ease-out ${leaving ? "opacity-0 pointer-events-none" : "opacity-100"}`}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(28,114,147,0.10),transparent_62%)]" />
      <img
        src="/images/logo-symbol.png"
        alt=""
        aria-hidden="true"
        className="relative h-24 md:h-32 w-auto"
        style={{ animation: "splash-pop 0.85s cubic-bezier(.18,.85,.25,1) both" }}
      />
      <img
        src="/images/logo-wordmark.webp"
        alt="Mediterranean Dream"
        className="relative h-6 md:h-8 w-auto mt-5"
        style={{ animation: "splash-rise 0.6s ease-out 0.72s both" }}
      />
      <span
        className="relative inline-block h-[2px] bg-[#C9A84C] rounded-full mt-4"
        style={{ animation: "splash-line 0.55s ease-out 1.15s both" }}
      />
    </div>
  );
}
